import { render, staticRenderFns } from "./ButtonFloat.vue?vue&type=template&id=52d2098b&scoped=true&"
import script from "./ButtonFloat.vue?vue&type=script&lang=js&"
export * from "./ButtonFloat.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFloat.vue?vue&type=style&index=0&id=52d2098b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2098b",
  null
  
)

export default component.exports